import { useParams } from '@tanstack/react-router'

import { CalloutDetailsScreen } from '@/screens/CalloutDetailsScreen'
import { ServicePageShell } from '@/screens/ServicePageShell'
import { formatRelativeDateTime } from '@/lib/relativeDateTime'
import { useCalloutDetails } from '@/screens/useCalloutDetails'

export function CalloutDetailsScreenContainer() {
  const serviceId = useParams({ from: '/callouts/$id', select: (p) => p.id })
  const details = useCalloutDetails(serviceId)

  if (details.kind === 'loading') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Callout details</h1>
          <p className="text-sm text-slate-600">Loading callout…</p>
        </main>
      </div>
    )
  }

  if (details.kind === 'error') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Callout details</h1>
          <p className="text-sm text-slate-600">
            Unable to load callout details right now.
          </p>
        </main>
      </div>
    )
  }

  if (details.kind === 'not_found') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Callout details</h1>
          <p className="text-sm text-slate-600">
            Callout not found. Check the link or return to the callouts list.
          </p>
        </main>
      </div>
    )
  }

  const displayId = details.screenProps.publicId ?? details.screenProps.serviceId

  return (
    <ServicePageShell
      serviceTypeLabel="Callout"
      serviceId={displayId}
      customerName={details.screenProps.customerName}
      customerId={details.screenProps.customerId}
      customerPublicId={details.screenProps.customerPublicId}
      scheduledAtLabel={
        details.screenProps.isWholeDay
          ? `${formatRelativeDateTime(details.screenProps.startTime, { includeTime: false })} · No Time`
          : formatRelativeDateTime(details.screenProps.startTime)
      }
      initialIssue={details.screenProps.issueSummary}
      activeTab="details"
      basePath="/callouts/$id"
      currentStatus={details.screenProps.status}
      statusChanges={details.screenProps.statusChanges}
      getAuthorDisplayName={details.screenProps.getAuthorDisplayName}
    >
      <CalloutDetailsScreen {...details.screenProps} showHeader={false} />
    </ServicePageShell>
  )
}
